import { Component, OnInit } from '@angular/core';
import { TabsModule } from 'ngx-bootstrap';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-diritti-oneri',
  templateUrl: './diritti-oneri.component.html',
  styleUrls: ['./diritti-oneri.component.css']
})
export class DirittiOneriComponent extends AppComponentGenericComponent implements OnInit {
	dirittiEsecutiviPignoramento: any[];
	limitiPignoramentoStipendio: any[];

	dirittiOneriRiscossione: any[];
	dirittiOneriRiscossioneSync: Subscription;

	tipiDirittiOneriRiscossione: any[];
	tipiDirittiOneriRiscossioneSync: Subscription;

	nuovoRiscossione: any = {
		comune_id : '',
		tipo_diritto_onere_id : 'null',
		valore : '',
		tipo : 'Euro'
	}

	riscossioneModificato: any = {
		id : '',
		comune_id : '',
		tipo_diritto_onere_id: 'null',
		valore : '',
		tipo : 'Euro'
	}

	nDirEsPignDescrizione: string = '';
	nDirEsPignImpMax: string = '';
	nDirEsPignValore: string = '';

	nLimPignStipDescrizione: string = '';
	nLimPignStipImpMax: string = '';
	nLimPignStipFrazione: string = '';

	constructor(protected dataService: DataService) {
		super(dataService, 'diritti-oneri');
		this.dirittiOneriRiscossione = [];
		this.tipiDirittiOneriRiscossione = [];
		this.dirittiEsecutiviPignoramento = [];
		this.limitiPignoramentoStipendio = [];
	}

	ngOnInit() {
		this.dirittiOneriRiscossioneSync = this.dataService.dirittiOneriRiscossione$.subscribe(
			dirittiOneriRiscossione => {
				this.resetRiscossione();
				if (dirittiOneriRiscossione) {
					this.dirittiOneriRiscossione = dirittiOneriRiscossione;
				}
				else {
					this.dirittiOneriRiscossione = [];
				}
			});
		this.tipiDirittiOneriRiscossioneSync = this.dataService.tipiDirittiOneriRiscossione$.subscribe(
			tipiDirittiOneriRiscossione => {
				if (tipiDirittiOneriRiscossione) {
					this.tipiDirittiOneriRiscossione = tipiDirittiOneriRiscossione;
				}
				else {
					this.tipiDirittiOneriRiscossione = [];
				}
				this.nuovoRiscossione.comune_id = this.dataService.getComuniService().getComuneId();
				console.log("tipiDirittiOneriRiscossione", this.tipiDirittiOneriRiscossione, this.nuovoRiscossione);
			});
	}

	resetRiscossione() {
		this.nuovoRiscossione.comune_id = '';
		this.nuovoRiscossione.tipo_diritto_onere_id = 'null';
		this.nuovoRiscossione.valore = '';
		this.nuovoRiscossione.tipo = 'Euro';
		this.riscossioneModificato.id = '';
		this.riscossioneModificato.comune_id = '';
		this.riscossioneModificato.tipo_diritto_onere_id = 'null';
		this.riscossioneModificato.valore = '';
		this.riscossioneModificato.tipo = 'Euro';
	}

	aggiungiRiscossione() {
		if (this.nuovoRiscossione.tipo_diritto_onere_id != 'null' && this.nuovoRiscossione.valore != '') {
			this.nuovoRiscossione.tipo_diritto_onere_id = Number(this.nuovoRiscossione.tipo_diritto_onere_id);

			this.dataService.insert("diritti_oneri", this.nuovoRiscossione, true, (error,res) => {
				if (error) {
					//this.dataService.openMessage('INSERIMENTO DIRITTO/ONERE','si è verificato un errore');
				}
				if(res) {
					this.resetRiscossione();
				}
			});
		}
	}

	apriModificaRiscossione(riscossione: any) {
		this.riscossioneModificato.id = riscossione.id;
		this.riscossioneModificato.comune_id = riscossione.comune_id;
		this.riscossioneModificato.tipo_diritto_onere_id = Number(riscossione.tipo_diritto_onere_id);
		this.riscossioneModificato.valore = riscossione.valore;
		this.riscossioneModificato.tipo = riscossione.tipo;
	}

	salvaModificaRiscossione() {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: this.riscossioneModificato.id });
		this.riscossioneModificato.tipo_diritto_onere_id = Number(this.riscossioneModificato.tipo_diritto_onere_id);

		this.dataService.update("diritti_oneri", localFilters, this.riscossioneModificato, true, (error,res) => {
			if(res){
				this.resetRiscossione();
			}
		});
	}

	annullaModificaRiscossione(riscossione: any) {
		this.resetRiscossione();
	}

	eliminaRiscossione(riscossione: any) {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: riscossione.id });

		this.dataService.delete("diritti_oneri", localFilters, true, (error,res) => {
			if (error) {
				//this.dataService.openMessage('ELIMINAZIONE RISCOSSIONE','si è verificato un errore');
			}
			if(res){
				this.resetRiscossione();
			}
		});
	}

	dirittiEsecutiviPignoramentoAdd() {
		if (this.nDirEsPignDescrizione != '' && this.nDirEsPignImpMax != '' && this.nDirEsPignValore != '') {
			let nuovoDiritto = {
				descrizione : this.nDirEsPignDescrizione,
				massimo : this.nDirEsPignImpMax,
				valore : this.nDirEsPignValore,
			}

			this.dirittiEsecutiviPignoramento.push(nuovoDiritto);

			this.nDirEsPignDescrizione = '';
			this.nDirEsPignImpMax = '';
			this.nDirEsPignValore = '';
		}
	}

	limitiPignoramentoStipendioAdd() {
		if (this.nLimPignStipDescrizione != '' && this.nLimPignStipImpMax != '' && this.nLimPignStipFrazione != '') {
			let nuovoLimite = {
				descrizione : this.nLimPignStipDescrizione,
				massimo : this.nLimPignStipImpMax,
				frazione : this.nLimPignStipFrazione,
			}

			this.limitiPignoramentoStipendio.push(nuovoLimite);

			this.nLimPignStipDescrizione = '';
			this.nLimPignStipImpMax = '';
			this.nLimPignStipFrazione = '';
		}
	}

	ngOnDestroy() {
		this.dirittiOneriRiscossioneSync.unsubscribe();
		this.tipiDirittiOneriRiscossioneSync.unsubscribe();
	}

}
